import { useEffect, useState } from "react";
import api from "@/lib/api";

// THE role list, from the server (GET /admin/roles): every role that isn't retired, by key (what a person's
// record stores), plus the name the screens show — a role can be renamed without its key moving.
let _roles = null;

export function getRoles(force = false) {
  if (!_roles || force) _roles = api.get("/admin/roles").then((r) => ({ roles: r.data.roles || [], names: r.data.names || {} }));
  return _roles;
}

export function useRoles() {
  const [roles, setRoles] = useState([]);
  useEffect(() => { getRoles().then((d) => setRoles(d.roles)).catch(() => setRoles([])); }, []);
  return roles;
}

export function useRoleNames() {
  const [names, setNames] = useState({});
  useEffect(() => { getRoles().then((d) => setNames(d.names)).catch(() => setNames({})); }, []);
  return names;
}
